import { z } from 'zod';

export const jsonValueSchema = z.json().register(z.globalRegistry, { id: 'JsonValue' });
export type JsonValue = z.infer<typeof jsonValueSchema>;
